import { Button } from "@at/design-system-elements";
import {
  TypeFiesta,
  TypeInsignia,
  ThemeSelectors,
  TypeBeetle,
  TypeToledo,
} from "@at/design-system-foundation";
import styled from "styled-components";

import { isUserInRedButtonTest } from "../../../utils/ab-test/ab-test.util";

export const LeasingProductModalHeaderAndParagraphContainer = styled.div`
  margin-top: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)};
`;

export const LeasingProductModalHeader = styled(TypeInsignia).attrs({
  as: "h3",
})`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
  margin-top: ${({ theme }) => ThemeSelectors.getGroupTwoSpacing(theme)};
  color: ${({ theme }) => ThemeSelectors.getLegacyBlue(theme)};
  font-variation-settings: "wght" 400;
`;

export const LeasingProductModalSubHeader = styled(TypeToledo).attrs({
  as: "h3",
})`
  margin: ${({ theme }) => ThemeSelectors.getGroupFiveSpacing(theme)} 0;
  color: ${({ theme }) => ThemeSelectors.getATBlue(theme)};
  font-variation-settings: "wght" 400;
`;

export const LeasingProductModalParagraph = styled(TypeFiesta).attrs({
  as: "p",
})`
  display: block;
  color: ${({ theme }) => ThemeSelectors.getLegacyDarkBlue(theme)};
  font-variation-settings: "wght" 400;
`;

export const LeasingModalCTA = styled(Button)`
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;

export const LeasingProductModalInfoBlock = styled.div`
  background-color: ${({ theme }) =>
    isUserInRedButtonTest
      ? ThemeSelectors.getLightGrey(theme)
      : ThemeSelectors.getColorDecorBgSurfaceSoft(theme)};
  padding: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;

export const LeasingProductModalInfoBlockTitle = styled(TypeBeetle)`
  font-variation-settings: "wght" 500;
  margin-bottom: ${({ theme }) => ThemeSelectors.getGroupFourSpacing(theme)};
`;

export const EmailLink = styled.a`
  color: ${({ theme }) => ThemeSelectors.getActionColor(theme)};
`;
